import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const BellFilledSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6208 21.4284C20.8198 17.2565 25.918 5.94814 19.0008 1.92813C12.0814 -2.0932 4.89904 8.01322 2.41162 12.0135L18.6208 21.4284ZM8.28115 17.5043C7.96078 19.929 8.51483 22.2135 10.9315 22.861C12.6382 23.3183 13.9485 22.6041 14.9004 21.349L8.28115 17.5043Z", fill: "var(--magritte-ui-icon-color)" }) }));
const BellFilledSize24 = hoc(forwardRef(BellFilledSize24Component), 'BellFilledSize24');

export { BellFilledSize24 as default };
//# sourceMappingURL=BellFilledSize24.js.map
